import React from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress, Backdrop, Typography } from '@mui/material';

const GlobalLoader = () => {
  const isLoading = useSelector((state) => state.ui.loading);

  if (!isLoading) return null;

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1000,
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
      open={isLoading}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: '#7522D1',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            }
          }}
        />
      </Box>
      <Typography
        variant="h6"
        sx={{
          color: '#1a1a1a',
          fontWeight: 600,
          letterSpacing: '0.5px',
          animation: 'pulse 1.5s infinite ease-in-out'
        }}
      >
        Please wait...
      </Typography>

      <style jsx="true">{`
        @keyframes pulse {
          0% { opacity: 0.6; }
          50% { opacity: 1; }
          100% { opacity: 0.6; }
        }
      `}</style>
    </Backdrop>
  );
};

export default GlobalLoader;
